var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.36 39.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#ccc;stroke-miterlimit:10;}.cls-2{fill:#f37d21;}.cls-3{fill:#dd2231;}.cls-3,.cls-4{fill-rule:evenodd;}.cls-4{fill:#f3a839;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.5,
    width: 69.36,
    height: 38.19,
    rx: 2.83
  }), /*#__PURE__*/React.createElement("g", {
    id: "Creditcards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    className: "cls-2",
    x: 30.28,
    y: 10.85,
    width: 9.8,
    height: 17.49
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-3",
    d: "M30.9,19.59a11.1,11.1,0,0,1,4.28-8.74,11.13,11.13,0,1,0,0,17.49,11.11,11.11,0,0,1-4.28-8.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-4",
    d: "M53,26.49v-.43h-.12l-.13.29-.13-.29h-.11v.43h.08v-.33l.12.28h.08l.13-.28v.33Zm-.72,0v-.36h.14v-.07H52v.07h.15v.36Zm1.07-6.9a11.21,11.21,0,0,1-18.12,8.75,11.07,11.07,0,0,0,0-17.49A11.21,11.21,0,0,1,53.3,19.59Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterCard);
export default __webpack_public_path__ + "static/media/mater-card.01281dffd1b0297c205c68ac5b0b40f3.svg";
export { ForwardRef as ReactComponent };